// Maps audit-log / activity entries to the back-office page that owns them.
// Used by the dashboard's recent-activity rows, the TopBar's notification
// popover, and the audit page's target column.
//
// Backend `entityType` is a closed Postgres ENUM (see /Users/loft/tkt-backend
// src/models/AuditLog.ts:7,28): 'order' | 'ticket' | 'scan_item' | 'payment'
// | 'user' | 'event'. Anything else from the action/metadata falls through
// to the prefix fallback (mock/legacy data) and finally 'audit'.

const ACTIVITY_TARGET_PAGES: Record<string, string> = {
  order: 'orders',
  orders: 'orders',
  ticket: 'orders',
  tickets: 'orders',
  scan_item: 'access-control',
  scanItem: 'access-control',
  payment: 'transactions',
  payments: 'transactions',
  transaction: 'transactions',
  transactions: 'transactions',
  txn: 'transactions',
  user: 'people',
  users: 'people',
  customer: 'people',
  staff: 'people',
  event: 'events',
  events: 'events',
  // Legacy / mock-data aliases — kept for backwards compat with offline mocks.
  payout: 'payouts',
  payouts: 'payouts',
  payout_batch: 'payouts',
  request: 'event-requests',
  'event-request': 'event-requests',
  event_request: 'event-requests',
  template: 'design',
  design: 'design',
  campaign: 'design',
  message_template: 'design',
  risk: 'risk',
  case: 'risk',
  dispute: 'risk',
  chargeback: 'risk',
  settlement: 'reconciliation',
  reconciliation: 'reconciliation',
};

const ACTIVITY_TARGET_PREFIXES: [RegExp, string][] = [
  [/^PAY-/i, 'payouts'],
  [/^TXN-/i, 'transactions'],
  [/^ORD-/i, 'orders'],
  [/^REQ-/i, 'event-requests'],
  [/^EVT-/i, 'events'],
  [/^TPL-/i, 'design'],
  [/^RSK-/i, 'risk'],
  [/^STL-/i, 'reconciliation'],
  [/^USR-/i, 'people'],
];

export const resolveActivityTargetPage = (item: { entityType?: string; target?: string } | null | undefined): string => {
  if (!item) return 'audit';
  const type = (item.entityType || '').toLowerCase();
  if (type && ACTIVITY_TARGET_PAGES[type]) return ACTIVITY_TARGET_PAGES[type];
  const target = String(item.target || '');
  for (const [re, page] of ACTIVITY_TARGET_PREFIXES) {
    if (re.test(target)) return page;
  }
  return 'audit';
};
